import _ from "lodash";
import CustomerFilterRequest from "../model/CustomerFilterRequest";
import CS2AggregatorService from "../../Services/CS2AggregatorService";
import { CustomerFilterViewMoel } from "../model/CustomerFilterViewModel";
import { PolicySearchDto } from "../model/PolicySearchDto";
import { CustomerFilterResponseDto } from "../model/CustomerFilterResponseDto";
import * as CustomerApi from "../services/CustomerAPI";
import { AxiosResponse } from "axios";
import { LookupData } from "../../Models/LoookupData";
import LookupService from "../../Services/LookupService";
import { SelectOption } from "../../shared/components/input";
import CommonDataService from "../../Services/CommonDataService";
import { CompanyDto } from "../model/CompanyDto";
import { CommonUtility } from "../../Services/CommonUtility";

class CustomerStandardSearchService
{
    IsFilterInputValid(filterRequest : CustomerFilterRequest) : boolean
    {
        if (_.isEmpty(filterRequest.firstName?.trim())
            && _.isEmpty(filterRequest.lastName?.trim())
            && _.isEmpty(filterRequest.homePhone?.trim())
            && _.isEmpty(filterRequest.eMail?.trim())
            && _.isEmpty(filterRequest.address1?.trim())
            && _.isEmpty(filterRequest.address2?.trim())
            && _.isEmpty(filterRequest.city?.trim())
            && _.isEmpty(filterRequest.state?.trim())            
            && _.isEmpty(filterRequest.zipCode?.trim())
            && _.isEmpty(filterRequest.custNumber?.toString()?.trim())
            // Policy fields
            && _.isEmpty(filterRequest.policyNumber?.trim())
            && _.isEmpty(filterRequest.PolicyTypeId?.trim())
            && _.isEmpty(filterRequest.CompanyId?.trim())
            && _.isEmpty(filterRequest.WritingCompanyId?.trim())
            && !filterRequest.PolEffDate)
        {
            return false;
        }

        if (!_.isEmpty(filterRequest.policyNumber?.trim())){
            if (filterRequest.policyNumber?.trim()?.length < 3)
                {
                    return false;
                }

            return true;
        }
       

        if (!_.isEmpty(filterRequest.custNumber?.toString()?.trim()))
        {
             if ((isNaN(filterRequest.custNumber) || (filterRequest.custNumber?.toString()?.trim().length < 3))) {
                    return false;
                }
            
            return true;
        }

        if (!_.isEmpty(filterRequest.firstName?.trim()) && filterRequest.firstName?.trim()?.length < 2)
        {
            return false;
        }

        if (!_.isEmpty(filterRequest.lastName?.trim()) && filterRequest.lastName?.trim()?.length < 2)
        {
            return false;
        }

        // Validate actual phone number (without dashes)
        if (!_.isEmpty(filterRequest.homePhone?.trim()) && filterRequest.homePhone?.trim()?.replace(/\D/g, '').length < 6 )
        {
            return false;
        }

        if (!_.isEmpty(filterRequest.address1?.trim()) && filterRequest.address1?.trim()?.length < 2 )
        {
            return false;
        }

        if (!_.isEmpty(filterRequest.address2?.trim()) && filterRequest.address2?.trim()?.length < 2 )
        {
            return false;
        }

        // If state is selected, make sure atleast one of the other address search parameter is also filled.
        if (!_.isEmpty(filterRequest.state?.trim())){
            if (filterRequest.address1?.trim()?.length >= 2){
                return true
            }
            
            if (filterRequest.address2?.trim()?.length >= 2){
                return true
            }

            if (!_.isEmpty(filterRequest.city?.trim())){
                return true
            }

             if (!_.isEmpty(filterRequest.zipCode?.trim())){
                return true
            }

            return false;
        }

        return true;
    }

    async FetchCustomers(filterRequest : CustomerFilterRequest) : Promise<AxiosResponse<CustomerFilterViewMoel[]>>
    {
        let customerData : CustomerFilterViewMoel[] = []
        let custFilterRequest = {...filterRequest }; 
        if (custFilterRequest.custNumber) {
            custFilterRequest.custNumber = parseFloat(custFilterRequest.custNumber.toString());
        }
        else {
            custFilterRequest.custNumber = null;
        }

        // Trim down all the search inputs.
        custFilterRequest.firstName = custFilterRequest.firstName?.trim();
        custFilterRequest.lastName = custFilterRequest.lastName?.trim();
        custFilterRequest.eMail = custFilterRequest.eMail?.trim();
        custFilterRequest.homePhone = custFilterRequest.homePhone?.replaceAll('-','').trim();
        custFilterRequest.address1 = custFilterRequest.address1?.trim();
        custFilterRequest.address2 = custFilterRequest.address2?.trim();
        custFilterRequest.city = custFilterRequest.city?.trim();
        custFilterRequest.state = custFilterRequest.state?.trim();
        custFilterRequest.zipCode = custFilterRequest.zipCode?.replaceAll('-', '').trim();
        custFilterRequest.policyNumber = custFilterRequest.policyNumber?.trim();
        custFilterRequest.PolicyTypeId = _.isEmpty(custFilterRequest.PolicyTypeId?.toString()?.trim()) ? null : custFilterRequest.PolicyTypeId;
        custFilterRequest.CompanyId = _.isEmpty(custFilterRequest.CompanyId?.toString()?.trim()) ? null : custFilterRequest.CompanyId;
        custFilterRequest.WritingCompanyId = _.isEmpty(custFilterRequest.WritingCompanyId?.toString()?.trim()) ? null : custFilterRequest.WritingCompanyId;
        if (custFilterRequest.PolEffDate) {
            custFilterRequest.PolEffDate = CommonUtility.datetimeToDateOnly(custFilterRequest.PolEffDate as Date);
        }

        return await CustomerApi.SearchCustomers(custFilterRequest);
    }

    public fetchComponentInitData = async () => {
        let countryList = await LookupService.fetchCountries();
        let stateUSList = await LookupService.fetchUSStates();
        let stateCanadaList = await LookupService.fetchCanadaStates();
        let policyTypeList = await LookupService.fetchPolicyType();
        let companyListRaw = await CommonDataService.getCompanyList();
        let companyList = this.mapCompanyDataToSelectOptions(companyListRaw);
        let parentCompanyList = companyList.filter(item => item.value === item.parentId);
        let writingCompanyList = companyList.filter(item => item.value !== item.parentId);
        let stateUSOptions = stateUSList ? stateUSList.map(item => {
            return {
                label: item.lookupValue,
                value: item.lookupCode,
                isInactive: false
            }
        }) : [];
        return {
            countryList: this.mapToSelectOptions(countryList),
            stateCanadaList: this.mapToSelectOptions(stateCanadaList),  
            stateUSList: stateUSOptions,
            policyTypeList: this.mapToSelectOptions(policyTypeList),
            companyList,
            parentCompanyList,
            writingCompanyList,
        };
    }

    private mapToSelectOptions = (lookupData: LookupData[]): SelectOption[] => {
            return lookupData?.map(item => {
                return {
                    label: item.lookupValue,
                    value: item.id,
                    isInactive: item.inactive
                };
            });
        }

    private mapCompanyDataToSelectOptions = (lookupData: CompanyDto[]): SelectOption[] => {
        return lookupData?.map(item => {
            return {
                label: item.description || '',
                value: item.id || '',
                isInactive: !item.isActive,
                parentId: item.parentCompanyId
            };
        });
    }
}

export default CustomerStandardSearchService;